import React from 'react'
import PropTypes from 'prop-types'

import { H2, Button } from '../Common'

import style from './SignInError.scss'

import thinking from '../../images/emojis/thinking.svg'

function SignInErrorBlocked({ user }) {
  return (
    <div className={style.wrapper}>
      <img src={thinking} alt="Pensativo!" />
      <H2>Oi {user.name.split(' ')[0]}!</H2>
      <p>
        parece que existe um assunto pendente relacionado ao contrato da sua conta.
        <br />
        entre em contato com o suporte para maiores informações.
      </p>
      <Button
        href="mailto:servicedesk@hiplatform.com?subject=Ajuda com assunto pendente sobre conta"
        className={style.button}
        xl
      >
        servicedesk@hiplatform.com
      </Button>
    </div>
  )
}

SignInErrorBlocked.propTypes = {
  user: PropTypes.object,
}

export default SignInErrorBlocked



// WEBPACK FOOTER //
// ./src/components/Pages/SignInErrorBlocked.js